import { render } from "./MultipleSelection.vue?vue&type=template&id=40d3c741"
import script from "./MultipleSelection.vue?vue&type=script&lang=js"
export * from "./MultipleSelection.vue?vue&type=script&lang=js"
script.render = render

export default script